import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPlus,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import actions from "../../../redux/groceryList/action";
import {
  getItemVatLabels,
  getCounterpartPriceLabel,
} from "../../../helper/vat";
import "../Checkout.page.css";

const img_placeholder = require("../../../assets/images/prodotto.png");

class CartItemRow extends Component {
  incrementQty = () => {
    const { item } = this.props;
    const step = item.quantity_step ? item.quantity_step : 1;
    const qty = item.quantity + step;
    this.props.changeQuantity({
      quantity: qty,
      item: item,
    });
  };

  decrementQty = () => {
    const { item } = this.props;
    let qty = item.quantity;
    if (item.quantity_step) {
      if (qty > item.quantity_step) {
        qty -= item.quantity_step;
      }
    } else if (qty > 1) {
      qty--;
    }
    this.props.changeQuantity({
      quantity: qty,
      item: item,
    });
  };

  deleteProduct = () => {
    this.props.deleteProduct({
      item: this.props.item,
    });
  };

  getDisplayPrice = () => {
    const { item } = this.props;
    if (
      item.offer_price !== null &&
      item.offer_price !== undefined &&
      parseFloat(item.offer_price) > 0
    ) {
      return parseFloat(item.offer_price);
    }
    return parseFloat(item.price);
  };

  render() {
    const { item } = this.props;
    const imageSrc =
      item.images && item.images.length > 0 && item.images[0].image_file
        ? item.images[0].image_file
        : img_placeholder;
    const unitPrice = this.getDisplayPrice();
    const subtotal = item.currentPrice
      ? parseFloat(item.currentPrice)
      : unitPrice * item.quantity;

    // Riga su una sola linea (desktop): immagine, blocco nome/prezzo unitario,
    // stepper quantita', subtotale e cestino sono figli diretti della griglia,
    // cosi' non restano vuoti verticali tra le colonne. Su mobile la stessa
    // griglia si ripiega su due livelli (vedi Checkout.page.css).
    return (
      <div className="co-item">
        <div className="co-item__img">
          <img
            src={imageSrc}
            alt={item.field1 || ""}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // previene il loop
              currentTarget.src = img_placeholder;
            }}
          />
        </div>

        <div className="co-item__info">
          <p className="co-item__name">{item.field1}</p>
          {item.variety && (
            <span className="co-item__variety">{item.variety}</span>
          )}
          {!item.no_price && (
            <span className="co-item__price">
              <span className="co-item__unit">{`€ ${unitPrice.toFixed(2)}`}</span>
              {/* Regime IVA della riga: "IVA esclusa/inclusa" e, con il flag
                  show_vat_percentage, l'aliquota del prodotto. */}
              {getItemVatLabels(item).map((label, i) => (
                <span className="co-item__vat-note" key={i}>
                  {label}
                </span>
              ))}
              {/* show_price_with_and_without_vat: prezzo unitario nell'altro
                  regime IVA, su una riga sua. */}
              {getCounterpartPriceLabel(item, unitPrice) && (
                <span className="co-item__vat-counterpart">
                  {getCounterpartPriceLabel(item, unitPrice)}
                </span>
              )}
            </span>
          )}
        </div>

        <div className="co-item__qty">
          <button
            className="co-item__qty-btn"
            onClick={this.decrementQty}
            type="button"
            aria-label="Diminuisci quantità"
          >
            <FontAwesomeIcon icon={faMinus} />
          </button>
          <input
            className="co-item__qty-input"
            type="text"
            value={item.quantity}
            readOnly
            aria-label="Quantità"
          />
          <button
            className="co-item__qty-btn"
            onClick={this.incrementQty}
            type="button"
            aria-label="Aumenta quantità"
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        {!item.no_price && (
          <span className="co-item__subtotal">
            {`€ ${subtotal.toFixed(2)}`}
          </span>
        )}

        <button
          className="co-item__remove"
          onClick={this.deleteProduct}
          type="button"
          aria-label="Rimuovi prodotto"
          title="Rimuovi"
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    groceryList: state.groceryList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeQuantity: (data) => dispatch(actions.changeQuantity(data)),
    deleteProduct: (data) => dispatch(actions.deleteProduct(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItemRow);
